import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: process.env.REACT_APP_PROJECTID, // find this at manage.sanity.io or in your sanity.json
  dataset: process.env.REACT_APP_DATASET, // this is from those question during 'sanity init'
  apiVersion: "2021-10-21", // use a UTC date string
  useCdn: false, // `false` if you want to ensure fresh data
  token: process.env.REACT_APP_TOKEN,
});
